import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, LoginStateInterface } from './store/login/login.state';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { WAITINGROOM_ROUTE } from '../../routes';
import { RouterHelperService } from '../utils/router-helper/router-helper.service';
import { DoTanSessionResetAction } from './store/login/login.action';

const TAN_LENGTH = 6;

@Injectable()
export class TanLoginGuard {
    constructor(private store: Store<AppState>,
                private router: RouterHelperService) {
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.store.select(s => s.login).pipe(
            take(1),
            map((login: LoginStateInterface) => {
                if (!login.loggedIn) {
                    return true;
                }

                if (this.isDifferentTanSession(login.tan, route.queryParams['tan'])) {
                    this.store.dispatch(new DoTanSessionResetAction());
                    return true;
                }

                this.router.navigate([WAITINGROOM_ROUTE]);
                return false;
            }));
    }

    private isDifferentTanSession(sessionTan: string, urlTan: string): boolean {
        const normalizedSessionTan = this.normalizeTan(sessionTan);
        const normalizedUrlTan = this.normalizeTan(urlTan);

        return this.isValidTan(normalizedSessionTan)
            && this.isValidTan(normalizedUrlTan)
            && normalizedSessionTan !== normalizedUrlTan;
    }

    private isValidTan(tan: string): boolean {
        return tan.length === TAN_LENGTH;
    }

    private normalizeTan(tan: string): string {
        return (tan || '').replace(/\s+/g, '').toUpperCase();
    }
}
